'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _RenderSubregion = require('./RenderSubregion');

var _RenderSubregion2 = _interopRequireDefault(_RenderSubregion);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _RenderSubregion2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/RenderSubregion/index.js
// module id = 277
// module chunks = 11